import { FormControl, FormGroup, Validators } from '@angular/forms';
import { of } from 'rxjs';
import {
  ACCESS,
  AGE_GROUP,
  CATEGORY,
  getSelectable
} from '../../../core/constants/options';
import { IEditorCtx, IInputCtx, ISelectCtx } from '../../../shared/form';
import { IId } from '../../../shared/models/id';
import { ISelectable } from '../../../shared/models/selectable';

export interface IDiscussionForm {
  name: string;
  category_id: number;
  age_group_id: number;
  access: number;
  description: string;
  file: number[];
}

export interface IDiscussionPatch {
  title: string;
  text: string;
  category: IId;
  ageGroup: IId;
  access: IId;
}

export class DiscussionForm {
  readonly fields = {
    title: new FormControl(null, [Validators.required]),
    category: new FormControl(null, [Validators.required]),
    ageGroup: new FormControl(null, [Validators.required]),
    access: new FormControl(null, [Validators.required]),
    text: new FormControl(null, [Validators.required])
  };

  readonly group = new FormGroup(this.fields);

  readonly title: IInputCtx = {
    control: this.fields.title,
    placeholder: `Title`,
    hint: `Online education in California schools`,
    required: true
  };

  readonly category: ISelectCtx<ISelectable> = {
    control: this.fields.category,
    placeholder: `Category`,
    getTitle: (value) => value.title,
    options: of([
      { id: 1, title: 'School Life' },
      { id: 2, title: 'College Resources' },
      { id: 3, title: 'After School & Summer' },
      { id: 4, title: 'RoundPier Stuff' },
      { id: 5, title: 'Research' },
      { id: 6, title: 'Entrepreneurship' },
      { id: 7, title: 'Politics' },
      { id: 8, title: 'Economics & Finance' },
      { id: 9, title: 'STEM' }
    ])
  };

  readonly ageGroup: ISelectCtx<ISelectable> = {
    control: this.fields.ageGroup,
    placeholder: `Age Group`,
    getTitle: (value) => value.title,
    options: of([
      { id: 1, title: '3-6 years' },
      { id: 2, title: '7-9 years' },
      { id: 3, title: '10-13 years' },
      { id: 4, title: '14-17 years' },
      { id: 5, title: 'any' }
    ])
  };

  readonly access: ISelectCtx<ISelectable> = {
    control: this.fields.access,
    placeholder: `Access`,
    getTitle: (value) => value.title,
    options: of([
      { id: 1, title: 'Open for all' },
      { id: 2, title: 'Open to RoundPier members' }
    ])
  };

  readonly text: IEditorCtx = {
    control: this.fields.text
  };

  constructor() {}

  // TODO: fix this shameless crutch
  // add support for different types of articles
  adjustFormToPrivateArticle() {
    this.fields.category.patchValue({ id: 10 });
    this.fields.category.updateValueAndValidity();

    this.fields.ageGroup.patchValue({ id: 1 });
    this.fields.ageGroup.updateValueAndValidity();

    this.fields.access.patchValue({ id: 1 });
    this.fields.access.updateValueAndValidity();
  }

  public patch({ title, access, text, category, ageGroup }: IDiscussionPatch) {
    this.group.patchValue({
      title,
      text,
      category: getSelectable(CATEGORY, category),
      ageGroup: getSelectable(AGE_GROUP, ageGroup),
      access: getSelectable(ACCESS, access)
    });
  }

  public getData(docs: number[]) {
    const fields = this.fields;
    const mapped: IDiscussionForm = {
      name: fields.title.value,
      category_id: fields.category.value['id'],
      age_group_id: fields.ageGroup.value['id'],
      access: fields.access.value['id'],
      description: fields.text.value,
      file: docs
    };

    this.group.reset();

    return mapped;
  }
}
